export function renderValuationsTable(clientData) {
	let allValuations = clientData.equity['C'].valuations.sort((a, b) => (Number(a.date) > Number(b.date) ? -1 : 1));

	let emptyState = `<div class="bg-grey-lightest rounded border-grey grey-text center-align p-2">No stock prices have been added yet</div>`;
	let valuationsMarkup = `
        ${
			allValuations.length
				? `
            <div class="table-wrap card px-4">
                <div class="sm-hz-scroll-no-margin">
                    <table id="valuationsSortTable" class="highlight table-content">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Description</th>
                                <th class="center-align">Share Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${allValuations
								.map(
									(valuation, index) =>
										`
                                <tr>
                                    <td class="text-sm" data-sort='${valuation.date}'>
                                        ${moment.unix(valuation.date).format('MMM D, YYYY')}
                                    </td>
                                    <td class="text-sm">
                                        ${valuation.notes}
                                    </td>
                                    <td class="text-sm center-align" data-sort='${Number(valuation.sharePrice.replace(/[^.\d]/g, ''))}'>
                                        ${Number(valuation.sharePrice.replace(/[^.\d]/g, '')).toLocaleString('en-US', usp)}
                                    </td>
                                </tr>
                                `
								)
								.join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        `
				: `${emptyState}`
		}`;

	document.getElementById('valuationsTableModal').innerHTML = valuationsMarkup;
}

/** Latest valuation ($/share) on or before asOfUnixSeconds, or null. Mirrors profile.js's getPriceAtTs. */
export function getValuationAsOf(clientData, shareClass, asOfUnixSeconds) {
	const t = Number(asOfUnixSeconds);
	if (!t) return null;
	const vals = clientData?.equity?.[shareClass]?.valuations || [];
	let bestDate = -Infinity;
	let bestPrice = null;
	for (const v of vals) {
		const d = Number(v?.date);
		if (d <= t && d > bestDate) {
			bestDate = d;
			bestPrice = Number(String(v?.sharePrice ?? '').replace(/[^-.\d]/g, ''));
		}
	}
	return bestPrice;
}
